import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import ExternalLink from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import useMediaQuery from '@mui/material/useMediaQuery';

import SharedAsset from '#client/components/SharedAsset';
import { useTrackLinkPressed } from '#client/utils/reporting';

import useStyles from './useStyles';

// Images
const AmendmentIcon = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SharedAsset src="/icon/product/amendment-256.svg" width={80} alt="amendment" {...props} />
);

const AmendmentBanner = ({
  amendmentPricing,
  amendmentUrl
}) => {
  const classes = useStyles();
  const smallViewport = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const handleClick = useTrackLinkPressed({
    linkText: 'GET AN AMENDMENT',
    destination: amendmentUrl
  });
  return (
    <Paper className={classes.amendment}>
      <Grid container direction="row" alignItems="center">
        {!smallViewport && (<AmendmentIcon className={classes.desktopOnly} />)}
        <div className={classes.amendmentContainer}>
          <Grid container direction="row" alignItems="center" wrap="nowrap" style={{ width: 'auto' }}>
            {smallViewport && (<AmendmentIcon className={classes.mobileOnly} />)}
            <Title level={2} variant="md-alt" gutterBottom>
              Need to update your business information?
            </Title>
          </Grid>
          <Text size="md" align="center" className={classes.amendmentDescription}>
            Amend your business information with the state for
            <Text size="md" bold tag="span">{`$${amendmentPricing} + state fees`}</Text>
          </Text>
        </div>
        <ExternalLink
          className={classes.amendmentButton}
          href={amendmentUrl}
          onClick={handleClick}
        >
          GET AN AMENDMENT
        </ExternalLink>
      </Grid>
    </Paper>
  );
};

AmendmentBanner.propTypes = {
  amendmentPricing: PropTypes.number.isRequired,
  amendmentUrl: PropTypes.string.isRequired
};

export default AmendmentBanner;
